const recIcons = {
  // TODO refactor to include only REC 4 and WOBO classes.
  realestate: 'mdi-home-city', //'mdi-city-variant',
  building: 'mdi-office-building',
  storey: 'mdi-stairs',
  room: 'mdi-floor-plan',
  device: 'mdi-cog-transfer',
  sensor: 'mdi-thermometer-lines',
  window: 'mdi-window-closed',
  roofouter: 'mdi-home-roof',
  facade: 'mdi-wall',
  georeferenceorigo: 'mdi-map-marker',
  geometry: 'mdi-vector-square',
  observation: 'mdi-chart-timeline-variant',
  authdomain: 'mdi-shield-key',
  authprofile: 'mdi-account-key',
  postaladdress: 'mdi-mail', // 'mdi-road-variant',
  point: 'mdi-map-marker',
  entry: 'mdi-office-building-marker', // 'mdi-location-enter',
  level: 'mdi-stairs-box',
  lmapartment: 'mdi-floor-plan',
  architecturearea: 'mdi-set-square',
  cookingroom: 'mdi-countertop-outline',
  bathroom: 'mdi-shower',
  livingroom: 'mdi-sofa',
  bedroom: 'mdi-bed-king',
  door: 'mdi-door-closed-lock',
  wardrobe: 'mdi-wardrobe',
  dishwasher: 'mdi-dishwasher',
  combinedrefrigeratorfreezer: 'mdi-fridge',
  washingmachine: 'mdi-washing-machine',
  storage: 'mdi-archive-outline',
  cleaningcupboard: 'mdi-vacuum',
  cleaningroom: 'mdi-vacuum',
  bicyclegarage: 'mdi-bicycle',
  entrance: 'mdi-mailbox',
  hallway: 'mdi-rug',
  breaker_panel: 'mdi-fuse',
  garage: 'mdi-garage',
  power_loss_alarm: 'mdi-power-plug-outline',
  communication_loss_alarm: 'mdi-network-outline',
  air_temperature_sensor: 'mdi-thermometer',
  relative_humidity_sensor: 'mdi-water-percent',
  iaqsensorequipment: 'mdi-weather-windy',
  electrical_meter: 'mdi-counter',
  water_meter: 'mdi-counter',
  energy_usage_sensor: 'mdi-lightning-bolt',
  water_usage_sensor: 'mdi-water',
  residentialapartment: 'mdi-floor-plan',
  onetimepasswordcredentialscommand: 'mdi-state-machine',
  physicaldigitalkeycredentialscommand: 'mdi-state-machine',
  digitallock: 'mdi-lock-smart',
  exceptionevent: 'mdi-alert-outline',
  wirelessrouter: 'mdi-router-wireless',
  patchport: 'mdi-ethernet',
  telecommunicationroom: 'mdi-server-network',
  ethernetswitch: 'mdi-switch',
  battery: 'mdi-power-plug-battery-outline',
  low_battery_alarm: 'mdi-battery-outline',
  ethernetport: 'mdi-ethernet',
  patchpanel: 'mdi-router-network',
}

const alternativeRecIcons = {
  power_loss_alarm: 'mdi-power-plug-off-outline',
  communication_loss_alarm: 'mdi-network-off-outline',
  low_battery_alarm: 'mdi-battery-off-outline',
}

const defaultRecIcon = 'mdi-asterisk'

// Returns icon for REC type/class.
// Expects an IRI
function recIcon(type, alternative = false) {
  const typeShort = type?.short?.toLowerCase()
  // TODO refa cto to variable for the icosn, eg altIcon and icon, then only one return
  if (alternative)
    return (
      alternativeRecIcons[typeShort] || recIcons[typeShort] || defaultRecIcon
    )
  return recIcons[typeShort] || defaultRecIcon
}

export { recIcons, defaultRecIcon, recIcon }
